<!-- fieldAwesome.vue -->
<template>
  <Datepicker
    autoApply
    textInput
    :readonly="schema.readonly"
    v-model="value"
    :disabled="disabled"
    :placeholder="usedFormat"
    :format="usedFormat"
    :enableTimePicker="false"
    :min-date="minDate"
    :max-date="maxDate"
  />
  <button
    class="btn btn-outline-secondary"
    v-if="!disabled"
    @click="value = null"
  >
    Clear
  </button>
</template>

<script>
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import { abstractField } from 'vfg-next'

export default {
  computed: {
    minDate() {
      return this.schema.minDate ?? null
    },
    maxDate() {
      return this.schema.maxDate ?? null
    },
    usedFormat() {
      return this.schema.format ?? 'dd/MM/yyyy'
    }
  },
  components: {
    Datepicker: Datepicker
  },
  mixins: [abstractField]
}
</script>

<style>
.dp--clear-btn {
  display: none !important;
}
</style>
